/**
 * Shefira's shadow seen from above, heading east (ADR 0067): the stand-in
 * drawn by code until her art is packed (`DRAGON_ART`). Wings spread, horns,
 * and the broken frost chain still hanging below her neck, which gives her
 * away even as a shadow (docs/LORE.md). One character per pixel, `#` filled.
 */
export const SHEFIRA_SILHOUETTE: readonly string[] = [
  '........................................................',
  '.................##.....................................',
  '.................####...................................',
  '..................#####.................................',
  '..................#######...............................',
  '..................########..............................',
  '...........#......#########.............................',
  '............###....#########............................',
  '............######.##########...........................',
  '.............################...........................',
  '..............###############...........................',
  '..............################..........................',
  '.......###.....###############..........................',
  '........######################..........................',
  '.........#####################..........................',
  '..........####################..........................',
  '...........###################..........................',
  '............##################..........................',
  '..............#################.........................',
  '...............################..#.......##.............',
  '................#################.........##............',
  '.................#################.........######.......',
  '...............###################################......',
  '..##........#########################################...',
  '..################################################......',
  '####.#############################.........######.......',
  '..##...#########################......#...##............',
  '...#.......###.################.#......#.##.............',
  '..............#################..#....#..#..............',
  '............##################.........#................',
  '...........###################........#.................',
  '..........####################..........................',
  '.........#####################.........#................',
  '........######################..........................',
  '.......###.....###############..........................',
  '..............################..........................',
  '..............###############...........................',
  '.............################...........................',
  '............######.##########...........................',
  '............###....#########............................',
  '...........#......#########.............................',
  '..................########..............................',
  '..................#######...............................',
  '..................#####.................................',
  '.................####...................................',
  '.................##.....................................',
  '........................................................',
];
